module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-engagement"
  }, [_c('div', {
    staticClass: "property-engagement__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__legend"
  }, [_c('graph-key', {
    attrs: {
      "graph-key-items": _vm.keyItems,
      "flex": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__sort"
  }, [_vm._v("\n      Sort By:\n      "), _vm._l((_vm.sorts), function(s, index) {
    return [(index !== 0) ? _c('span', [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('a', {
      class: {
        'active': (_vm.currentSort.name === s.name)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentSort = s
        }
      }
    }, [_vm._v(_vm._s(s.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__graph-container"
  }, [_c('property-engagement-graph', {
    staticClass: "property-engagement__graph",
    attrs: {
      "chart-data": _vm.chartData
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-engagement__title"
  }, [_c('h4', [_vm._v("Known Consumer Reach and Engagement by Property")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c280ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/propertyEngagementReach/PropertyEngagementReach.vue
// module id = 1869
// module chunks = 0